import React, { useEffect, useState } from "react";
import AggregatorTable from "./AggregatorTable";
import BarChartsMain from "./BarChartsMain";
import HorziBarChartsMain from "./HorizontalStackBarChart";
import {  getAggregatorDetailDataByDate } from "../../ActionCreator";
import moment from "moment";

function AggregatorPerformance({ appliedDate }) {
  const [isLoading, setIsLoading] = useState(false);
  const [aggregatorData, setAggregatorData] = useState([]);

  const getAggregatorData = () => {
      const sDate = appliedDate?.from
          ? moment(appliedDate.from).format("DD-MM-YYYY")
          : "";
        const eDate = appliedDate?.to
          ? moment(appliedDate.to).format("DD-MM-YYYY")
          : "";
    setIsLoading(true);
    getAggregatorDetailDataByDate(sDate,eDate, (res) => {
      setIsLoading(false);
      const data = res?.data?.filter((item) => item?.aggregatorName)
      setAggregatorData(data);
    });
  };

  useEffect(() => {
    getAggregatorData();
  }, [appliedDate]);
  return (
    <>
      <div>
        <AggregatorTable data={aggregatorData} />
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "50px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1" }}>
          <div
            style={{
              background: "#fff",
              border: "1px solid #00000026",
              borderRadius: "10px",
              padding: "20px",
              height: "100%",
            }}
          >
            <BarChartsMain
              barcolor={"#EBB569"}
              xAxisDataKey={"aggregatorName"}
              barData={aggregatorData}
              yAxisLabel={"approvalPercentage"}
              heading={"Aggregator Conversion Rates"}
              className={"common-heading"} heightcustom={"300px"} angelTilt={"-20"}
            />
          </div>
        </div>

        <div style={{ flex: "1" }}>
          <div
            style={{
              background: "#fff",
              border: "1px solid #00000026",
              borderRadius: "10px",
              padding: "20px",
              height: "100%",
            }}
          >
            <HorziBarChartsMain
              heading={"Approved vs Disbursed Trend"}
              xAxisDataKey={"aggregatorName"}
              barData={aggregatorData}
              dataKeyName1={"utilizedBudget"}
              dataKeyName2={"totalRevenue"}
              barcolor1={"#FF999A"}
              barcolor2={"#4FA564"}
              LegendLeft={"Cost"}
              LegendRight={"totalRevenue"}
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginTop: "0px",
                marginBottom: "14px",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AggregatorPerformance;
